import Settings from "./utils/CarrotConfig"

export function AdminShellRedirector() {
  function inIframe() {
    return window.self !== window.top
  }

  if (!inIframe()) {
    const adminShellUrl = Settings.ADMIN_SHELL_URL
    window.location.href = `${adminShellUrl}/admin/legacy${window.location.pathname}`
  }

  return null
}
